import { StatusGlyph } from './StateViews.jsx';
import { unitState } from '../lib/status.js';

/** systemd unit state. Glyph + colour + word — never colour alone. */
export function UnitPill({ unit }) {
  const state = unitState(unit);
  return (
    <span className={`pill pill--${state.tone}`}>
      <StatusGlyph tone={state.tone} shape={state.shape} />
      {state.label}
    </span>
  );
}

/** A quiet, uncoloured tag for classification (kind, tenant, action names). */
export function Tag({ children, mono = false, title }) {
  return (
    <span className={`tag${mono ? ' mono' : ''}`} title={title}>
      {children}
    </span>
  );
}

/** TLS presence. Reserved-status colours; the word carries the meaning. */
export function TlsBadge({ secured, label }) {
  const tone = secured ? 'good' : 'neutral';
  return (
    <span className={`pill pill--${tone} pill--sm`}>
      <StatusGlyph tone={tone} shape={secured ? 'disc' : 'hollow'} />
      {label || (secured ? 'TLS' : 'No TLS')}
    </span>
  );
}
